import { Link } from 'react-router-dom';
import type { FC } from 'react';

const trustCards = [
  {
    icon: 'ri-shopping-bag-3-line',
    title: 'Tysiące produktów',
    desc: 'Poznaj popularne produkty znalezione przez społeczność.'
  },
  {
    icon: 'ri-folders-line',
    title: 'Kategorie produktów',
    desc: 'Buty, ubrania, elektronika i wiele więcej.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Praktyczne poradniki',
    desc: 'Dowiedz się jak korzystać z Kakobuy bezpiecznie.'
  },
  {
    icon: 'ri-refresh-line',
    title: 'Aktualne informacje',
    desc: 'Regularnie aktualizowane treści i dane.'
  }
];

const HeroSection: FC = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 md:pt-[72px] overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20e-commerce%20workspace%20flat%20lay%20with%20laptop%20displaying%20colorful%20analytics%20dashboard%2C%20surrounded%20by%20fashion%20accessories%20including%20sneakers%2C%20sunglasses%2C%20watch%2C%20and%20fabric%20swatches%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20diffused%20lighting%2C%20clean%20aesthetic%20editorial%20style%2C%20uncluttered%20composition%20with%20generous%20negative%20space%2C%20contemporary%20retail%20concept%20photography&width=1600&height=1000&seq=hero-bg-kakobuy-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - produkty i kategorie"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50/95"></div>
      </div>

      <div className="section-container relative z-10 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-6 animate-fade-in">
              <i className="ri-sparkling-line text-sm"></i>
              <span>#1 Baza wiedzy w Polsce</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6 animate-fade-in-up">
              Kakobuy Spreadsheet Polska –<br />
              <span className="text-primary-500">Znajdź najlepsze produkty szybciej</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-in-up animation-delay-200">
              Kompletna baza Kakobuy Spreadsheet dla Polski. Odkrywaj popularne produkty, sprawdzaj kategorie, porównuj możliwości i korzystaj z praktycznych poradników zakupowych.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start animate-fade-in-up animation-delay-300">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-md shadow-sm transition-all duration-200"
              >
                Kakobuy Spreadsheet
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="btn-outline w-full sm:w-auto px-8 py-3.5 text-sm font-semibold border-accent-400 text-accent-700 hover:bg-accent-50 rounded-md transition-all duration-200"
              >
                Buy It Now
                <i className="ri-shopping-cart-line ml-2"></i>
              </a>
            </div>

            <div className="mt-6 animate-fade-in-up animation-delay-400">
              <Link
                to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik"
                className="inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <span>Zobacz poradnik dla początkujących</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none animate-fade-in-up animation-delay-300">
            <div className="bg-background-50/90 backdrop-blur-sm rounded-xl p-6 md:p-8 border border-background-200/70">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-0.5 h-5 bg-primary-500 rounded-full"></div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900">Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {trustCards.map((card, i) => (
                  <div key={i} className="p-4 rounded-lg bg-background-100/70 hover:bg-background-100 transition-colors">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3">
                      <i className={`${card.icon} text-lg`}></i>
                    </div>
                    <h4 className="font-semibold text-sm text-foreground-900 mb-1">{card.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in animation-delay-600">
          <a href="#categories" className="flex flex-col items-center gap-1 text-foreground-400 hover:text-foreground-600 transition-colors">
            <span className="text-xs">Przewiń w dół</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;